import { ROUTES } from '@sportninja/common/constants/app'

export interface RegistrationDetailsPathRecord {
  uid: string
  schedule: { uid: string }
  is_official_budget_line?: boolean | null
}

/**
 * Where a My Registrations row opens. SN-8480 — a Team Rep's own Team Budget line
 * has nothing to show on Info (no player, no form), so it opens on its Billing
 * Schedule; every other registration opens on Info.
 */
export const getRegistrationDetailsPath = (
  record: RegistrationDetailsPathRecord
): string => {
  const tab = record.is_official_budget_line ? 'billing' : 'info'

  return `${ROUTES.REGISTRATION_DETAILS.ROOT}/${record.schedule.uid}/${tab}?registration_id=${record.uid}`
}
